module.exports = __webpack_public_path__ + "img/7.dd084996.jpg";